import { createStore } from '@uhg-abyss/web/tools/createStore';
import { config } from '@uhg-abyss/web/tools/config';
//  below code for store using react but this als doesn't work with selectinput
import { usStates } from '@src/CommonComponents/TopFilters/stateCodes';

export const useApiStore = createStore((set) => ({
  apiData: null,
  setApiData: (data) => {
    set({ apiData: data });
  },
}));
export const useApiTrendStore = createStore((set) => ({
  apiTrendData: null,
  setApiTrendData: (data) => {
    set({ apiTrendData: data });
  },
}));
export const useApiYOYStore = createStore((set) => ({
  apiYOYData: null,
  setApiYOYData: (data) => {
    set({ apiYOYData: data });
  },
}));
export const useNpiStore = createStore((set) => ({
  apiNpiData: null,
  setApiNpiData: (data) => {
    set({ apiNpiData: data });
  },
}));
export interface TaxId {
  Tin: string;
  Tinname: string;
}
export interface ProductType {
  ClaimProducts: Array<string>;
  ClaimSystem: string;
  Lob: Array<string>;
  ProductName: string;
}
export const metricCardErrorStore = createStore((set)=> ({
  errorMessage: {TypeOfError:0,Message:''},
  infoMessage: '',
  Type: '',

  setErrorMessage: (message) => {
    set({
      errorMessage: {
        TypeOfError: message.TypeOfError,
        Message: message.Message,
      },
      Type: message.Type,
    });
  },
  setInfoMessage: (message) => set({ infoMessage: message }),
}));

// export interface TopFilterTin {
//   Tin: string;
//   TinName: string;
// }
// export interface TopFilterNpi {
//   Npi: string;
//   NpiName: string;
// }
// Removed duplicate TopFilterTin interface
export interface TopFilterTin {
  Tin: string;
  TinName: string;
}
export interface PAFilterTin {
  title: string;
  value: string;
}
export interface PAFilterNpi {
  title: string;
  value: string;
}
export interface PAFilterSpecialty {
  title: string;
  value: string;
}
export interface TopFilterLob {
  Lob: string;
}
export interface TopFilterNpi {
  Npi: string;
  NpiName: string;
}

export interface TopFilterSpeciality {
  Speciality: string;
}

export interface GapsInCare {
  TimePeriod: any;
  Lob: any;
  Tin: any;
  Npi: any;
}
export interface PACaseSubmission {
  TimePeriod: any;
  Lob: any;
  Tin: any;
  Npi: any;
}
export interface PriorAuthFilter {
  timePeriod: string;
  timePeriodText: string;
  taxId: any;
  lineOfBusiness: string;
  providerSetting: string;
  channel: string;
  serviceSetting: string;
  serviceCategory: string;
  npi: any;
  specialty: any;
}
export interface POCAFilters {
  timePeriod: any;
  taxId: any;
  lob: string;
  channel: string;
  npi: any;
}
export interface SelectDataVal {
  tabIndex: number;
  groupName: string;
}
export interface TopFilterTimePeriod {
  FilterText: string;
  Default: string;
  StartDate: string;
  EndDate: string;
}
export interface State {
  value: string;
  State: string;
}
export const getUSERSessionData = (JSON.parse(sessionStorage.getItem('state') || '{}'))?.selectedCorporateTin?.value !== '' ? (JSON.parse(sessionStorage.getItem('state') || '{}'))?.selectedCorporateTin : (JSON.parse(sessionStorage.getItem('currentUser') || '{}'))[0]?.selectedTin;

export const useSessionStorageStore = createStore((set) => ({
  isDrawerOpen: false,
  setisDrawerOpen: (newValue) => {
    set({ isDrawerOpen: newValue });
  },
  reactAbyssValue: sessionStorage.getItem('reactAbyssValue') || '',
  setreactAbyssValue: (newValue) => {
    sessionStorage.setItem('reactAbyssValue', newValue);
    set({ reactAbyssValue: newValue });
    window.dispatchEvent(new CustomEvent('ReactToAngular'));
  },
  angularAbyssValue: sessionStorage.getItem('angularAbyssValue') || '',
  setangularAbyssValue: (newValue) => {
    sessionStorage.setItem('angularAbyssValue', newValue);
    set({ angularAbyssValue: newValue });
  },
}));
interface FilterState {
  taxId: TaxId[];
  selectedTaxId: string;
  topFilterTimePeriod: TopFilterTimePeriod;
  currentPage: string;
  stateArr: State[];
  selectedState: string;
  selectedStateName: string;
}
interface FilterAction {
  resetFilter: () => void;
  resetStateFilter: () => void;
  setTaxId: (newTaxid: string) => void;
  setTinName: (newTinName: string) => void;
  setTimepriod: (timeperiod: TopFilterTimePeriod) => void;
  updateState: (data: [{}]) => void;
  setState: (state: string) => void;
}
let stateChangeFlag = false;let selectedTinData;
const sessionValue = JSON.parse(sessionStorage.getItem('tinsListGC') || '{}');
const clusterStates = ['AR', 'NM', 'WV', 'CO'];
const orgName = sessionStorage.getItem('PreviousOrg');
selectedTinData = sessionValue[0];
// Guard: GoldCardLoader (or a cover-page TIN click) may have already set the
// correct selectedTaxId. Only seed from tinsListGC[0] when no specific TIN was
// chosen. gcCoverPageSelectedTin is written by the onClick handler immediately
// before window.location.reload(), so its presence here means a TIN was clicked.
if (!sessionStorage.getItem('gcCoverPageSelectedTin')) {
  sessionStorage.setItem('selectedTaxId', sessionValue[0]?.value);
  sessionStorage.setItem('selectedTinName', sessionValue[0]?.name);
}
let tindropdown: any[] = [];
let initialState = '';

const getTins = () => {
  const tinArray: any[] = [];
  tindropdown = [];

  const goldCardCustomTin = config('GOLD_CARD_CUSTOM_TIN');

  if (
    sessionStorage.getItem('multiTinNavigation') &&
    sessionStorage.getItem('multiTinNavigation') === 'true' &&
    goldCardCustomTin
  ) {
    const tinsSelectedValues: any = sessionStorage.getItem(
      'multiSelectedTinsGC'
    );
    const tinsSelectedArrayValues = JSON.parse(tinsSelectedValues);

    tinsSelectedArrayValues?.sort((a, b) => parseInt(a.TIN) - parseInt(b.TIN));
    tindropdown = tinsSelectedArrayValues?.map((tins) => {
      if (tins?.TINNAME === '') {
        tins.TINNAME = 'UNKNOWN';
      }
      const dataValue = {
        value: tins?.TIN,
        name: tins?.TINNAME,
      };
      return dataValue;
    });
    // selectedTinData = tindropdown[0];
    return tindropdown;
  } else {
    if (sessionValue) {
      return sessionValue;
    } else return [];
  }
};
export const useFilterStore = createStore<FilterState & FilterAction>((set) => ({
  // create fn expects a fn as its argument, we are giving set fn as parameter to create, to update the state managed by store
  taxId: getTins(),
  selectedTaxId: sessionStorage.getItem('selectedTaxId') || '', // set fn is used by zustand lib to update the state of filters
  selectedTinName: sessionStorage.getItem('selectedTinName'),
  topFilterTimePeriod: {
    FilterText: 'All',
    StartDate: 'All',
    EndDate: 'All',
    Default: 'All',
  },
  stateArr: [],
  selectedState: initialState,
  selectedStateName: initialState,
  setStateFlag: (val) => {
    set({ pageLoad: val });
    stateChangeFlag = val;
  },
  setTaxId: (newTaxid) => {
    set({ selectedTaxId: newTaxid });
    stateChangeFlag = true;
    sessionStorage.setItem('tabIndex', '0');
    sessionStorage.setItem('monTabIndex', '0');
    sessionStorage.setItem('npiTabIndex', '0');
  },
  setTinName: (newTinName) => {
    set({ selectedTinName: newTinName });
  },
  // setTaxId:(newTaxid:string) =>{
  //   const newTin = tinArray.find(item=>item.Tinname===newTaxid)
  //   let newTinvalue =tinArray[0].Tin  // 1st value of array
  //   if(newTin){
  //    newTinvalue = newTin.Tin
  //   }
  //   set({'selectedTinName':newTaxid})
  //   set({'selectedTaxId':newTinvalue})
  //   stateChangeFlag = true
  // },
  setTimepriod: (timeperiod) => set({ topFilterTimePeriod: timeperiod }),
  updateState: (newdata) => {
    if (newdata.length !== 0) {
      set({ stateArr: newdata });
      if (stateChangeFlag) {
        const stateInfoData = JSON.parse(
          sessionStorage.getItem('state') || '{}'
        );
        const stateData = stateInfoData['selectedState'];
        if (stateData?.value === '' && newdata.length > 0) {
          window.dispatchEvent(
            new CustomEvent('StateSyncGC', {
              detail: {
                name: usStates.find(
                  (item) => item.abbreviation === newdata[0].StateCode
                )?.name,
                value: newdata[0].StateCode,
              },
            })
          );
          set({ selectedState: newdata[0].StateCode });
          set({
            selectedStateName: newdata
              .map((state) => ({
                value: state.StateCode,
                title: usStates.find(
                  (item) => item.abbreviation === state.StateCode
                )?.name,
              }))
              ?.filter((item) => item.value === newdata[0].StateCode)[0]?.title,
          });
          stateChangeFlag = !stateChangeFlag;
        } else if (newdata.length > 0 && stateData?.value !== '') {
          const data = newdata.filter(
            (item) => item.StateCode === stateData?.value
          );
          if (!data.length) {
            window.dispatchEvent(
              new CustomEvent('StateSyncGC', {
                detail: {
                  name: usStates.find(
                    (item) => item.abbreviation === newdata[0].StateCode
                  )?.name,
                  value: newdata[0].StateCode,
                },
              })
            );
            set({ selectedState: newdata[0].StateCode });
            set({
              selectedStateName: newdata
                .map((state) => ({
                  value: state.StateCode,
                  title: usStates.find(
                    (item) => item.abbreviation === state.StateCode
                  )?.name,
                }))
                ?.filter((item) => item.value === newdata[0].StateCode)[0]
                ?.title,
            });
            stateChangeFlag = !stateChangeFlag;
          } else {
            set({ selectedState: stateData?.value });
            set({ selectedStateName: stateData?.name });
          }
        } else {
          window.dispatchEvent(
            new CustomEvent('StateSyncGC', { detail: { name: '', value: '' } })
          );
        }
      }
      initialState = newdata[0].StateCode;
    } else {
      initialState = '';
      set({ stateArr: [] });
      sessionStorage.setItem('selectedState', '');
      set({ selectedState: initialState });
      set({ selectedStateName: initialState });
    }
  },
  setState: (state) => {
    set({ selectedState: state });
    set({
      selectedStateName: usStates.find((item) => item.abbreviation === state)
        ?.name,
    });
  },
  resetTinFilter: () => {
    set({
      selectedTaxId: getTins()[0].Tin,
    });
    set({ selectedTinName: getTins()[0]?.Tinname });
  },
  resetStateFilter: () => {
    set({
      selectedState: initialState,
      topFilterTimePeriod: {
        FilterText: 'All',
        StartDate: 'All',
        EndDate: 'All',
        Default: 'All',
      },
    });
    //set({'selectedTinName':tinArray[0]?.Tinname})
  },
}));
export default useFilterStore;
